"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var GwsGameProvidersGamesListCtl = /** @class */ (function (_super) {
    __extends(GwsGameProvidersGamesListCtl, _super);
    function GwsGameProvidersGamesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_game_backend_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_backend_id; });
        _this.dk_game_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_title; });
        _this.dk_game_group_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_group_title; });
        _this.dk_game_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_url; });
        _this.dk_game_icon_filename = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_icon_filename; });
        _this.dk_game_icon_filename_1 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_icon_filename_1; });
        _this.dk_game_lines_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_lines_count; });
        _this.dk_game_desktop_w = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_desktop_w; });
        _this.dk_game_desktop_h = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_desktop_h; });
        _this.dk_game_is_new = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_is_new; });
        _this.dk_game_is_hot = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_is_hot; });
        _this.dk_game_is_freespin = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_is_freespin; });
        _this.dk_game_is_bonus = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_is_bonus; });
        _this.dk_game_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_is_locked; });
        _this.dk_wager_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wager_percent; });
        _this.dk_withdraw_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_percent; });
        _this.dk_jackpot_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.jackpot_percent; });
        _this.dk_tournament_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tournament_percent; });
        _this.dk_points_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.points_percent; });
        _this.dk_level_percent = UIUtils_1.UIUtils.IProp2Str(function (o) { o.level_percent; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_game_icon_full_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_icon_full_url; });
        _this.dk_game_icon_full_url_1 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.game_icon_full_url_1; });
        _this._errDialog = errDialog;
        return _this;
    }
    GwsGameProvidersGamesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            groups_filter: [],
            total: 0
        };
    };
    GwsGameProvidersGamesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    GwsGameProvidersGamesListCtl.prototype.getGroupsFilter = function () {
        return this.DATA.groups_filter;
    };
    GwsGameProvidersGamesListCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.ListGwsGameProviderGamesByGameProviderIdGet.exec({
            gws_gameprovider_id: key
        }, function (resp) {
            _this.DATA.data = [];
            //
            _this.DATA.groups_filter = [];
            var filter_map = new Map();
            //
            _this.DATA.total = resp.total_count;
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!filter_map.get(resp.list[i].group_title)) {
                    _this.DATA.groups_filter.push({ text: resp.list[i].group_title, value: resp.list[i].group_title });
                    filter_map.set(resp.list[i].group_title, resp.list[i].group_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    game_backend_id: resp.list[i].game_backend_id,
                    game_title: resp.list[i].title,
                    game_group_title: resp.list[i].group_title,
                    game_url: resp.list[i].url,
                    game_icon_filename: resp.list[i].icon_filename,
                    game_icon_filename_1: resp.list[i].icon_filename_1,
                    game_lines_count: resp.list[i].lines_count,
                    game_desktop_w: resp.list[i].game_desktop_w,
                    game_desktop_h: resp.list[i].game_desktop_h,
                    game_is_new: resp.list[i].is_new,
                    game_is_locked: resp.list[i].is_locked,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    game_icon_full_url: resp.list[i].game_icon_full_url,
                    game_icon_full_url_1: resp.list[i].game_icon_full_url_1,
                    wager_percent: resp.list[i].wager_percent,
                    jackpot_percent: resp.list[i].jackpot_percent,
                    game_is_hot: resp.list[i].is_hot,
                    tournament_percent: resp.list[i].tournament_percent,
                    points_percent: resp.list[i].points_percent,
                    withdraw_percent: resp.list[i].withdraw_percent,
                    level_percent: resp.list[i].levels_percent,
                    game_is_freespin: resp.list[i].is_fs,
                    game_is_bonus: resp.list[i].is_bon
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GwsGameProvidersGamesListCtl.prototype.AddGwsGameProviderGame = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddGwsGameProviderGame.exec({
            data: {
                gws_gameprovider_id: data.game_provider_id,
                backend_id: data.backend_id,
                title: data.game_title,
                group_title: data.game_group_title,
                url: data.game_url,
                icon_filename: data.game_icon_filename,
                icon_filename_1: data.game_icon_filename_1,
                lines_count: data.game_lines_count,
                game_desktop_w: data.game_desktop_w,
                game_desktop_h: data.game_desktop_h,
                is_new: data.game_is_new,
                is_hot: data.game_is_hot,
                is_locked: data.game_is_locked,
                is_freespin: data.game_is_freespin,
                is_bonus: data.game_is_bonus
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                game_backend_id: data.backend_id,
                game_title: data.game_title,
                game_group_title: data.game_group_title,
                game_url: data.game_url,
                game_icon_filename: data.game_icon_filename,
                game_icon_filename_1: data.game_icon_filename_1,
                game_lines_count: data.game_lines_count,
                game_desktop_w: data.game_desktop_w,
                game_desktop_h: data.game_desktop_h,
                game_is_new: data.game_is_new,
                game_is_hot: data.game_is_hot,
                game_is_locked: data.game_is_locked,
                game_icon_full_url: resp.game_icon_full_url,
                game_icon_full_url_1: resp.game_icon_full_url_1,
                wager_percent: resp.wager_percent,
                jackpot_percent: resp.jackpot_percent,
                tournament_percent: resp.tournament_percent,
                points_percent: resp.points_percent,
                withdraw_percent: resp.withdraw_percent,
                level_percent: resp.level_percent,
                game_is_freespin: data.game_is_freespin,
                game_is_bonus: data.game_is_bonus
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GwsGameProvidersGamesListCtl.prototype.EditGwsGameProviderGame = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditGwsGameProviderGame.exec({
                data: {
                    gws_gameprovider_game_id: data.key,
                    backend_id: data.backend_id,
                    title: data.game_title,
                    group_title: data.game_group_title,
                    url: data.game_url,
                    icon_filename: data.game_icon_filename,
                    icon_filename_1: data.game_icon_filename_1,
                    lines_count: data.game_lines_count,
                    game_desktop_w: data.game_desktop_w,
                    game_desktop_h: data.game_desktop_h,
                    is_new: data.game_is_new,
                    is_locked: data.game_is_locked,
                    is_hot: data.game_is_hot,
                    is_freespin: data.game_is_freespin,
                    is_bonus: data.game_is_bonus
                }
            }, function (resp) {
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.game_icon_full_url = resp.game_icon_full_url;
                _tmp.game_icon_full_url_1 = resp.game_icon_full_url_1;
                _tmp.game_backend_id = data.backend_id;
                _tmp.game_title = data.game_title;
                _tmp.game_group_title = data.game_group_title;
                _tmp.game_url = data.game_url;
                _tmp.game_icon_filename = data.game_icon_filename;
                _tmp.game_icon_filename_1 = data.game_icon_filename_1;
                _tmp.game_lines_count = data.game_lines_count;
                _tmp.game_desktop_w = data.game_desktop_h;
                _tmp.game_desktop_h = data.game_desktop_h;
                _tmp.game_is_new = data.game_is_new;
                _tmp.game_is_locked = data.game_is_locked;
                _tmp.game_is_hot = data.game_is_hot;
                _tmp.game_is_freespin = data.game_is_freespin;
                _tmp.game_is_bonus = data.game_is_bonus;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    GwsGameProvidersGamesListCtl.prototype.DeleteGwsGameProviderGame = function (GameProviderGameKey, onDone) {
        var _this = this;
        var _tmp = this.getById(GameProviderGameKey);
        if (_tmp) {
            webAApi_1.DoDeleteGwsGameProviderGame.exec({
                data: {
                    gws_gameprovider_game_id: GameProviderGameKey
                }
            }, function (resp) {
                _this.RemoveItem(GameProviderGameKey);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGameIsLocked.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    is_locked: isLocked
                }
            }, function (resp) {
                _tmp.game_is_locked = isLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameIsNew = function (key, isNew, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGameIsNew.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    is_new: isNew
                }
            }, function (resp) {
                _tmp.game_is_new = isNew;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameIsFreespin = function (key, isFs, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGameIsFreeSpin.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    is_freespin: isFs
                }
            }, function (resp) {
                _tmp.game_is_freespin = isFs;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameIsBonus = function (key, isBon, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGameIsBonus.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    is_bonus: isBon
                }
            }, function (resp) {
                _tmp.game_is_bonus = isBon;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameIsHot = function (key, isHot, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGameIsHot.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    is_hot: isHot
                }
            }, function (resp) {
                _tmp.game_is_hot = isHot;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameWagerPercent = function (key, percent, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGamePercentWager.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    wager_percent: percent
                }
            }, function (resp) {
                _tmp.wager_percent = percent;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameWithdrawPercent = function (key, percent, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGamePercentWithdraw.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    withdraw_percent: percent
                }
            }, function (resp) {
                _tmp.withdraw_percent = percent;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameJackpotPercent = function (key, percent, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGamePercentJackpot.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    jackpot_percent: percent
                }
            }, function (resp) {
                _tmp.jackpot_percent = percent;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameTournamentPercent = function (key, percent, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGamePercentTournament.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    tournament_percent: percent
                }
            }, function (resp) {
                _tmp.tournament_percent = percent;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGamePointsPercent = function (key, percent, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGamePercentPoints.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    points_percent: percent
                }
            }, function (resp) {
                _tmp.points_percent = percent;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersGamesListCtl.prototype.SetGwsGameProviderGameLevelsPercent = function (key, percent, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetGwsGameProviderGamePercentLevel.exec({
                data: {
                    gws_gameprovider_game_id: key,
                    level_percent: percent
                }
            }, function (resp) {
                _tmp.level_percent = percent;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return GwsGameProvidersGamesListCtl;
}(BaseController_1.BaseController));
exports.GwsGameProvidersGamesListCtl = GwsGameProvidersGamesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ctl/GwsGameProviderGamesListCtl.ts
// module id = 867
// module chunks = 0